import './app.css';
import App from './App.svelte';
import { mount } from 'svelte';
import { initGlobalErrorHandler } from './lib/client-log';

initGlobalErrorHandler();

const app = mount(App, { target: document.getElementById('app')! });

export default app;
